let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5jQCZ")).then(() => parcelRequire('vTm8n'));